import { t } from 'i18next';
import React, { PropsWithChildren, ReactElement, SyntheticEvent } from 'react';

import { useCurrentActor } from '../../hooks/useCurrentActor';
import useModalDispatch from '../../hooks/useModalDispatch';
import SignInModal from '../../modals/SignInModal';
import Link from '../Link';

interface SignInFormLinkProps {
  Component: any;
  label?: string | ReactElement;
}

const SignInFormLink: React.FC<PropsWithChildren<SignInFormLinkProps>> = ({ Component = Link, children, label }) => {
  const dispatchModal = useModalDispatch(SignInModal);
  const { actorType } = useCurrentActor();

  if (actorType !== 'GuestUser') {
    return null;
  }

  return (
    <Component
      icon="sign-in"
      label={label}
      onClick={(e: SyntheticEvent<any>) => {
        e.preventDefault();
        dispatchModal({});
      }}
    >
      {children || label || t('auth.newSessionLink')}
    </Component>
  );
};

export default SignInFormLink;
